<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-30 18:23:28
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-21 17:15:37
-->
<!--控制台layout-->
<template>
	<el-container class="layout-box">
		<el-header>
			<control-header></control-header>
		</el-header>
		<el-container class="inner-box">
			<el-aside v-if="!$route.meta.hideMenu" :style="`width: ${menuWidth}px`">
				<side-menu :vipUrl="vipUrl"></side-menu>
			</el-aside>
			<el-container class="container">
				<!-- 模版布局自带面包屑，自带边框边距 -->
				<template v-if="tenantInfo.friendVersion && vipUrl.includes(mainUrl)">
					<el-main>
						<demo-tem :path="mainUrl" />
					</el-main>
				</template>
				<template v-else>
					<el-main class="flex-column" v-if="$route.meta.useTemplate">
						<div class="use-template-content">
							<Panel :contentPaddingTop="0">
								<BreadCrumb slot="header"></BreadCrumb>
								<div class="width-100 main-box pt-12">
									<router-view :key="$route.fullPath" v-if="isRouterAlive" />
								</div>
							</Panel>
						</div>
					</el-main>
					<el-main style="background: none" v-else>
						<router-view :key="$route.fullPath" v-if="isRouterAlive" />
					</el-main>
				</template>

				<!-- 微信关注通知！ -->
				<follow class="follow" />
				<!-- 授权通知 -->
				<Update-notification
					class="follow"
					v-for="item in messageList"
					:key="item.id"
					:popupId="item.id"
					:title="item.title"
					:content="item.content"
				></Update-notification>
				<!-- 协作介绍功能弹框 -->
				<cooperate-introduce>
					<img class="radius-8" style="width: 960px" slot="introductionImg" src="@/assets/public/sample-cooperate-introduce.png" alt="" />
				</cooperate-introduce>

				<!-- 通知公告 -->
				<commonNotice ref="commonNotice"></commonNotice>
				<!-- 消息通知弹窗 -->
				<NoticeDialog></NoticeDialog>
				<!-- 新手引导弹窗 -->
				<newHandGuide></newHandGuide>
			</el-container>
		</el-container>
	</el-container>
</template>
<script>
import SideMenu from '../sideMenu';
import ControlHeader from './ControlHeader';
import { mapGetters, mapState } from 'vuex';
import UpdateNotification from '../updateNotification';
import { getNewPop, getPopup } from '@/api/home';
import follow from '@/components/follow';
import cooperateIntroduce from './components/cooperateIntroduce';
import commonNotice from './components/commonNotice';
import NoticeDialog from './components/noticeDialog';
import newHandGuide from './components/newHandGuide';
import demoTem from './components/demoTem';
export default {
	name: 'ControlLayout',
	components: {
		SideMenu,
		ControlHeader,
		UpdateNotification,
		follow,
		cooperateIntroduce,
		NoticeDialog,
		commonNotice,
		newHandGuide,
		demoTem,
	},
	provide() {
		return {
			reload: this.reload,
		};
	},
	data() {
		return {
			messageList: [],
			isRouterAlive: true,
			vipUrl: [
				'home',
				'achievements',
				'groupConf',
				'department',
				'tobeClaime',
				'trusteeship',
				'shopGroup',
				'extenTecord',
				'pallet',
				'selectionDecoration',
				'order',
				'emphasisTalent',
				'groupSeas',
				'contacts',
				'clueSeas',
				'tagManagement',
				'promotion',
				'myActivities',
				'colonelActivitySquare',
				'cooperativeColonel',
				'rulesSetting',
				'tagManage',
				'message',
				'talentObtain',
				'local',
			],
		};
	},
	watch: {
		updateInfo: {
			handler(val) {
				if (val.update) {
					// console.log('val', val);
					this.getNewPop();
				}
			},
			deep: true,
		},
	},
	mounted() {
		this.getPopup();
		clearInterval(window.__rdu__timer);
		// 初始化调用一次
		this.getNewPop();
		window.__rdu__timer = setInterval(this.getNewPop, 120000);
	},
	computed: {
		...mapState(['update']),
		...mapGetters(['showSideMenu', 'tenantInfo']),
		menuWidth() {
			return this.showSideMenu ? 148 : 0;
		},
		isHome() {
			return this.$route.path == '/index/home';
		},
		mainUrl() {
			const arr = this.$route.path.split('/');
			return ['/order/list', '/cooperationProgress/list'].includes(this.$route.path) ? arr[1] : arr[2];
		},
	},
	methods: {
		async getNewPop() {
			if (document.visibilityState === 'hidden') {
				return;
			}
			const { data, code } = await getNewPop();
			if (code === 0 && data.isShow) {
				this.$refs.commonNotice.show(data);
			}
		},
		async getPopup() {
			const { code, data } = await getPopup();
			if (code !== 0) return;
			this.messageList = data;
		},
		reload() {
			this.isRouterAlive = false;
			this.$nextTick(() => {
				this.isRouterAlive = true;
			});
		},
	},
	beforeDestroy() {
		window.clearInterval(window.__rdu__timer);
	},
};
</script>

<style scoped lang="less">
@header-height: 64px;
@page-minWidth: 1366px;
@menu-width: 200px;
.layout-box {
	min-width: @page-minWidth;
	margin: 0 auto;
	height: 100vh;
	overflow: hidden;
	background-color: @background-color-base;
	.inner-box {
		width: 100%;
		min-width: @page-minWidth;
		margin: 0 auto;
		overflow: hidden;
	}
	/deep/ .el-header {
		padding: 0;
		height: @header-height!important;
	}
	/deep/ .el-container {
		.el-header {
			padding: 0;
			min-width: @page-minWidth;
			height: @header-height!important;
			border-bottom: 1px solid @border-color-extra-light;
		}
		.el-aside {
			height: calc(100vh - @header-height);
			// width: @menu-width!important;
		}
		.el-main {
			padding: 0;
		}
		.page-content {
			margin: 16px 16px 0 16px;
			padding: 0;
			border-radius: 8px 8px 0 0;
			position: relative;
		}
		// .el-main {
		// 	position: relative;
		// 	padding: 16px 16px 0 16px !important;
		// 	background: @color-white;
		// 	border-radius: 2px 2px 0 0;
		// 	.pad {
		// 		padding: 12px 24px 0px;
		// 	}
		// }

		.el-menu {
			border-right: none;
		}
	}
	main {
		&::-webkit-scrollbar {
			width: 8px;
		}
		&::-webkit-scrollbar-thumb {
			height: 26px;
			border-radius: 3px;
			background-color: @color-gy6;
		}
	}
	.container {
		display: flex;
		flex-direction: column;
		position: relative;
	}
	.container_header {
		margin: 16px 16px 0 16px;
		border-radius: 2px 2px 0 0;
	}
	.follow {
		position: absolute;
		top: 15px;
		right: 16px;
	}
	.use-template-content {
		padding: 16px 16px 0 16px;
	}
}
</style>
